import React, { Component } from "react";
import { shareFacebook, shareWhatsapp, openNegishut } from "../Services/Sharing"
import "./Header.scss"

export default class Header extends Component {
  constructor() {
    super()
    this.state = {
      isShareActive: false
    }
    this.activateSharer = this.activateSharer.bind(this);
  }
  activateSharer() {
    this.setState({
      isShareActive: !this.state.isShareActive
    })
  }
  render() {
    return (
      <header>
        <div id="header">
          <div className="padding">
            <div className="container">
              {/* <div className="publisher">
                <a href="https://ynet.co.il/" target="_blank"><div className="ynet"></div></a>
              </div> */}
              <div className="elections-head"></div>
              <div className="head-logo">
                <img src={require("../../static/images/mobile/ynet.png")} />
                {/* <div className="ynet"></div> */}
                <div className="head-text">בחירות 
                  <span>2022</span>
                </div>
                <div className="head-line"></div>
              </div>
              <div className="heading">
                  <div className="sub-header">משחק הכיסאות</div>
                  <div className="logo">הרכיבו את הקואליציה שלכם</div>
              </div>
              {/* <div className="utils">
                <div className={`share${(this.state.isShareActive ? " active " : "")}`}>
                  <div onClick={shareWhatsapp} className="whatsapp"></div>
                  <div onClick={shareFacebook} className="facebook"></div>
                  <div onClick={this.activateSharer} className="sharer"></div>
                  <div onClick={openNegishut} className="negishut"></div>
                </div>
              </div> */}
            </div>
          </div>
        </div>
        {/* <div className="negishut_float" onClick={openNegishut}></div> */}
      </header>
    );
  }
}


// WEBPACK FOOTER //
// ./src/Components/Header/Header.jsx